import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import SideNav from './SideNav';
import { Outlet, useLocation } from 'react-router-dom';
import usePushNotifications from '../../hooks/usePushNotifications';

const Layout = () => {
  const location = useLocation();
  usePushNotifications(location.pathname);
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  const toggleSideNav = () => {
    try {
      setIsSideNavOpen(prev => !prev);
    } catch (error) {
    }
  };

  useEffect(() => {
    let isMounted = true;
    
    const handleResize = () => {
      try {
        if (isMounted && typeof window !== 'undefined' && window.innerWidth !== undefined) {
          const isLarge = window.innerWidth >= 1200;
          setIsLargeScreen(isLarge);
          setIsSideNavOpen(isLarge); // open on large, closed on small
        }
      } catch (error) {
      }
    };

    try {
      handleResize(); // Initial run
      if (typeof window !== 'undefined') {
        window.addEventListener("resize", handleResize);
      }
    } catch (error) {
    }
    
    return () => {
      isMounted = false;
      try {
        if (typeof window !== 'undefined') {
          window.removeEventListener("resize", handleResize);
        }
      } catch (error) {
      }
    };
  }, []);

  const contentClass = isLargeScreen
    ? isSideNavOpen
      ? "with-sidenav"
      : "full-width"
    : "";

  return (
    <>
      <Navbar
        toggleSideNav={toggleSideNav}
        isSideNavOpen={isSideNavOpen}
        isLargeScreen={isLargeScreen}
      />
      <SideNav isOpen={isSideNavOpen} toggleSideNav={toggleSideNav} />
      <div className={`content_wrapper ${contentClass}`}>
        <div className="container dashboard-container">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
